<template>
  <div v-if="!fetching">
    <ProductHeader v-bind="{ title: product.name }">
      <FileUpload @file-upload="updateCover">
        <template #button="{ fileUploadButtonClick }">
          <img
            v-if="cover"
            :srcset="cover.srcsets || ''"
            @load.once="onImageLoad"
            @click="fileUploadButtonClick"
            sizes="1px"
            :src="cover.url"
            class="block rounded w-full cursor-pointer"
          />
          <div
            v-else
            @click="fileUploadButtonClick"
            class="aspect-ratio-4/3 w-full rounded bg-gray-900 cursor-pointer"
          />
        </template>
      </FileUpload>
    </ProductHeader>
    <TheMenu />
    <div class="p-16">
      <Transition name="slide-right" mode="out-in">
        <RouterView />
      </Transition>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import FileUpload from '@/components/Ui/FileUpload.vue';
import mediableMixin from '@/mixins/mediableMixin';
import ProductHeader from '@/components/Products/ProductHeader.vue';
import TheMenu from './_packageId/components/TheMenu.vue';

export default {
  name: 'PackageBaseView',
  mixins: [mediableMixin],
  components: {
    ProductHeader,
    TheMenu,
    FileUpload,
  },
  props: {
    packageId: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    fetching: false,
  }),
  computed: {
    ...mapGetters('admin/products', ['product']),
    cover() {
      const { media = [] } = this.product || {};
      return media.find((item) => item.collection === 'images') || null;
    },
  },
  created() {
    const { packageId } = this;
    this.doGetProduct(packageId);
  },
  beforeRouteUpdate(to, from, next) {
    const { packageId: packageIdTo } = to.params;
    const { packageId: packageIdFrom } = from.params;
    if (packageIdTo !== packageIdFrom || this.product === null) {
      this.setCurrent(null);
      this.doGetProduct(packageIdTo);
    }
    next();
  },
  destroyed() {
    this.setCurrent(null);
  },
  methods: {
    ...mapActions('admin/products', ['getPackage', 'updateProductCover']),
    ...mapMutations('ui/products', ['setCurrent']),
    doGetProduct(packageId) {
      this.fetching = true;
      this.getPackage({ packageId, params: { include: 'media,categories,tags' } })
        .then(() => {
          this.fetching = false;
        })
        .catch(() => {
          this.fetching = true;
        });
    },
    updateCover({ config, data, success, error }) {
      const { packageId } = this;
      this.updateProductCover({ config, productId: packageId, formData: data })
        .then(() => {
          success();
        })
        .catch(() => {
          error();
        });
    },
  },
};
</script>
